(() => {
  const init = async (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variant = root.querySelector('[data-variant]');
    const labels = JSON.parse(root.querySelector('[data-carbon-labels]').textContent);
    const formatter = new Intl.NumberFormat(root.dataset.locale === 'de' ? 'de-CH' : 'en-CH', { style: 'currency', currency: root.dataset.currency || 'CHF', maximumFractionDigits: 0 });
    const form = root.querySelector('form');
    const formatOption = (option) => `${option.dataset.estimate === 'true' ? labels.approx + ' ' : ''}${formatter.format(Number(option.dataset.variantPrice) / 100)}`;
    [...variant.options].forEach((option) => { option.textContent = `${option.dataset.label} · ${formatOption(option)}`; });
    root.querySelectorAll('[data-base-price]').forEach((el) => { el.textContent = `${el.dataset.estimate === 'true' ? labels.approxFrom : labels.from} ${formatter.format(Number(el.dataset.basePrice) / 100)}`; });
    let equipment;
    const update = () => {
      const option = variant.selectedOptions[0];
      const isFrameset = option.dataset.estimate !== 'true';
      const selected = equipment.calculate(isFrameset);
      const price = `${option.dataset.estimate === 'true' ? labels.approx + ' ' : ''}${formatter.format((Number(option.dataset.variantPrice) + selected.delta) / 100)}${selected.unknown ? ' + ' + equipment.labels.onRequest : ''}`;
      root.querySelectorAll('[data-price]').forEach((el) => { el.textContent = price; });
      root.querySelector('[data-price-note]').textContent = option.dataset.estimate === 'true' ? labels.completeNote : labels.framesetNote;
      root.querySelector('[data-availability]').hidden = option.dataset.available === 'true';
      const summary = [option.dataset.label, ...selected.lines, price, root.querySelector('[data-price-note]').textContent].join('\n');
      root.querySelector('[data-summary]').textContent = summary;
      root.querySelector('[data-build-input]').value = summary;
      root.querySelector('[data-variant-input]').value = option.value;
      root.querySelector('[data-review]').hidden = true;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    equipment = await window.HilitePilotEquipment(root, update);
    if (!root.isConnected) return;
    variant.addEventListener('change', update);
    root.querySelectorAll('[data-choose]').forEach((button) => button.addEventListener('click', () => {
      variant.value = button.dataset.choose;
      update();
      variant.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      variant.focus({ preventScroll: true });
    }));
    form.addEventListener('submit', (event) => {
      if (root.dataset.liveRequests !== 'true') { event.preventDefault(); root.querySelector('[data-review]').hidden = false; }
    });
    root.querySelector('[data-form-button]').disabled = false;
    const hero = root.querySelector('[data-hero-cta]');
    const contact = root.querySelector('.tp-contact');
    const sticky = root.querySelector('[data-sticky]');
    let heroPast = false;
    let contactVisible = false;
    const refreshSticky = () => { sticky.hidden = !(heroPast && !contactVisible); };
    new IntersectionObserver(([entry]) => { heroPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; refreshSticky(); }).observe(hero);
    new IntersectionObserver(([entry]) => { contactVisible = entry.isIntersecting; refreshSticky(); }).observe(contact);
    update();
  };
  document.querySelectorAll('[data-titan-carbon-pilot]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-titan-carbon-pilot]').forEach(init));
})();
